import i18n from '@/plugins/i18n';
import { MULTI } from '@/components/AlertsV2/external-tag-grouping/extTags.constants';

const extTagsTableHeaders = [
  {
    name: i18n.global.t('alert.taggedAlertGroupName'),
    key: 'tagGroupName',
    width: '25%',
    sortable: true,
  },
  {
    name: i18n.global.t('alert.tagName'),
    key: 'tagName',
    width: '25%',
    sortable: true,
  },
  {
    name: i18n.global.t('alert.lastModified'),
    key: 'lastUpdatedAt',
    width: '19%',
    sortable: true,
  },
  {
    name: i18n.global.t('alert.created'),
    key: 'createdAt',
    width: '19%',
    sortable: true,
  },
  { name: i18n.global.t('alert.actions'), key: 'actions', width: '12%' },
];

const extTagFormDefaultData = {
  tagInfo: {
    tagName: '',
    tagGroupName: '',
    fmId: '',
    active: true,
    templateId: '',
  },
  webhook: {
    id: '',
    url: '',
    method: '',
  },
  extTagFields: {},
  extTagConditions: {},
};

const extTagFormStepLabels = [
  i18n.global.t('alert.creation'),
  i18n.global.t('alert.preview'),
  i18n.global.t('alert.webhookURL'),
];

const extTagTableInfo = {
  total: 0,
  isLoading: true,
};

const formUtilsDefaultData = {
  reloadExtTagTable: false,
  isError: false,
};

const webhookDefaultData = {
  conditionType: [],
  fmid: '',
  map: [],
  webhook: {},
};

const defaultErrorValues = {
  tagInfo: true,
  webhookInfo: true,
};

function validateAlphaNumbericInput(inputStr) {
  const regex = /^[a-zA-Z0-9_ ]*$/;
  return regex.test(inputStr);
}
function truncateDoubleBraces(inputString) {
  // Use regular expression to replace occurrences of {{ and }}
  const result = inputString.replace(/{{|}}/g, '');
  return result;
}

function isEnumTye(type) {
  return type === MULTI;
}
function validateRegex(validationList, value) {
  if (!Array.isArray(validationList)) {
    return '';
  }
  for (const validation of validationList) {
    const regex = new RegExp(validation.regex);
    const isValid = regex.test(value);
    if (!isValid) {
      return validation.error_message;
    }
  }
  return '';
}
export {
  extTagsTableHeaders,
  extTagFormStepLabels,
  extTagTableInfo,
  formUtilsDefaultData,
  extTagFormDefaultData,
  defaultErrorValues,
  webhookDefaultData,
  validateAlphaNumbericInput,
  truncateDoubleBraces,
  isEnumTye,
  validateRegex,
};
